import { render } from "./Vacaciones.vue?vue&type=template&id=f2227ecc&scoped=true"
import script from "./Vacaciones.vue?vue&type=script&lang=js"
export * from "./Vacaciones.vue?vue&type=script&lang=js"

import "./Vacaciones.vue?vue&type=style&index=0&id=f2227ecc&scoped=true&lang=css"
import "./Vacaciones.vue?vue&type=style&index=1&id=f2227ecc&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2227ecc"]])

export default __exports__